var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"page-stores"}},[_c('block-header-standard',{attrs:{"title":this.title[_vm.locale]}}),_c('store-list-grid',{attrs:{"apiUrl":"entertainment","model":"entertainment","categories":_vm.$store.getters.storeFilters,"categoryId":['5b9d3c7762973c001fd2c69a']}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }